import IGameAPI, { PrizeResults, RetryCountResponse, SpinResults } from "./IGameAPI";

export default class MockAPI implements IGameAPI {

    private static readonly PRIZES = {
        "prizes": [
            {
                "id": 278,
                "image": "https://g2.sunlight.net/media/games/slot/prize_images/%D1%87%D0%B0%D1%81%D1%8B_20_zyYV9tA.png",
                "description": "Дополнительная скидка +20% на все часы",
                "name": "Дополнительная скидка ..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 277,
                "image": "https://g9.sunlight.net/media/games/slot/prize_images/7_Q2D0Bad.png",
                "description": "Дополнительная скидка +7% при онлайн-заказе на ВСЕ СЕРЕБРО!",
                "name": "Дополнительная скидка ..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 276,
                "image": "https://g5.sunlight.net/media/games/slot/prize_images/%D0%91%D0%B5%D0%B7_%D0%B8%D0%BC%D0%B5%D0%BD%D0%B8-1_UEk9MKV.png",
                "description": "Карта гостя магазина METRO и 1 500 бонусов на любимые покупки",
                "name": "Карта гостя магазина ..",
                "deeplink": "http://metro-cc.ru/sunlight",
                "is_won": false
            },
            {
                "id": 275,
                "image": null,
                "description": "Повышение статуса в программе лояльности! Статус изменяется в течение 2х суток после игры.",
                "name": "Повышения статуса",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 274,
                "image": "https://g6.sunlight.net/media/games/slot/prize_images/15_%D0%BD%D0%B0_%D1%81%D0%B5%D1%80%D0%B5%D0%B1%D1%80%D0%BE_nmxZHoZ.png",
                "description": "Дополнительная скидка +15% при онлайн-заказе на ВСЕ СЕРЕБРО от 3000р.",
                "name": "Дополнительная скидка ..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 273,
                "image": "https://g9.sunlight.net/media/games/slot/prize_images/03_zJoGUOt.png",
                "description": "Золотые серьги «Бриллианты Якутии» (арт. 81222) - Часть 1",
                "name": "Часть 1 Золотые серьги ..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 272,
                "image": null,
                "description": "ЧЗолотое кольцо «Бриллианты Якутии» (арт. 57830) - Часть 1",
                "name": "Часть 1 Золотое кольцо ..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 271,
                "image": "https://g9.sunlight.net/media/games/slot/prize_images/5_SXm5cYh.png",
                "description": "Дополнительная скидка +5% на любой онлайн-заказ",
                "name": "Дополнительная скидка..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 270,
                "image": "https://g1.sunlight.net/media/games/slot/prize_images/%D0%A7%D0%B0%D1%81%D1%8B_%D1%8D%D0%BA%D1%81%D0%BA%D0%BB%D1%8E%D0%B7%D0%B8%D0%B2%D0%BD%D0%BD%D1%8B%D1%85_%D0%B1%D1%80%D0%B5%D0%BD%D0%B4%D0%BE%D0%B2_QLeEJz8.png",
                "description": "Cкидка +20% на часы ..",
                "name": "Cкидка +20% на часы ..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            },
            {
                "id": 268,
                "image": "https://g0.sunlight.net/media/games/slot/prize_images/09_zKHsgX7.png",
                "description": "2 дополнительных попытки (добавить кастомеру 2 попытки открытия)",
                "name":  "2 дополнительных попытки..",
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "is_won": false
            }
        ]
    };

    private static SPIN_RESULTS: SpinResults[] = [
        {
            prize: {
                "name": "Часть 1 Золотые серьги «Бриллианты Якутии» (арт. 81222) - для получения подарка необходимо собрать обе части. Ищите Часть 2 в списке подарков!",
                "image": "https://g9.sunlight.net/media/games/slot/prize_images/03_zJoGUOt.png",
                "is_full_complex": 0,
                "is_won": 1,
                "is_complex": 1,
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "id": 273     
            }
        },
        {
            prize: {
                "name": "Часть 1 Золотые серьги «Бриллианты Якутии» (арт. 81222) - для получения подарка необходимо собрать обе части. Ищите Часть 2 в списке подарков!",
                "image": "https://g9.sunlight.net/media/games/slot/prize_images/03_zJoGUOt.png",
                "is_full_complex": 0,
                "is_won": 0,
                "is_complex": 1,
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "id": 273 
            }     
        },
        {
            prize: {
                "name": "Cкидка +20% на часы эксклюзивных брендов CASIO, Adriatica, Essence, Pierre Ricaud",
                "image": "https://g1.sunlight.net/media/games/slot/prize_images/%D0%A7%D0%B0%D1%81%D1%8B_%D1%8D%D0%BA%D1%81%D0%BA%D0%BB%D1%8E%D0%B7%D0%B8%D0%B2%D0%BD%D0%BD%D1%8B%D1%85_%D0%B1%D1%80%D0%B5%D0%BD%D0%B4%D0%BE%D0%B2_QLeEJz8.png",
                "is_full_complex": 0,
                "is_won": 1,
                "is_complex": 0,
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "id": 270    
            }  
        },
        {
            prize: {
                "name": "2 дополнительных попытки в игре!",
                "image": "https://g0.sunlight.net/media/games/slot/prize_images/09_zKHsgX7.png",
                "is_full_complex": 0,
                "is_won": 0,
                "is_complex": 0,
                "deeplink": "https://sunlight.net/profile/promocodes/",
                "id": 268      
            }
        }
    ];

    private _gameInfo: any;

    constructor(private retryCount: number) {
    }

    public async init() {
        this._gameInfo = {
            "status": {
                "code": 200,
                "success": "1"
            },
            "content": {
                "first_screen": {
                    "available_tries_label": "Доступно вращений",
                    "my_prizes_label": "Мои подарки",
                    "rules_label": "Получить вращения",
                    "play_label": "Вращать",
                    "my_prizes_deeplink": "https://sunlight.net/profile/promocodes/"
                },
                "rules": {
                    "title": "Получить вращение",
                    "first_image": "",
                    "first_title": "Покупка от 3 000 р.",
                    "first_text": "1 дополнительное вращение",
                    "second_image": "",
                    "second_title": "Покупка от 20 000 р.",
                    "second_text": "2 дополнительных вращения",
                    "close_btn": "Закрыть"
                },
                "prizes": {
                    "title": "Подарки"
                },
                "won_prize": {
                    "title": "Ура, вы выиграли",
                    "play_again_label": "Сыграть ещё раз",
                    "my_prizes_label": "Мои подарки",
                    "close_btn": "Закрыть",
                    "another_part_text": "Осталось выиграть другую часть для получения подарка",
                    "won_prize_text": "Вы уже получали этот подарок"
                }
            }
        };
    }

    public get gameInfo(): any {
        return this._gameInfo;
    }

    public async fetchPrizes(): Promise<PrizeResults> {

        return MockAPI.PRIZES;
    }

    public async fetchRetryCount(): Promise<RetryCountResponse> {
        return {
            "status": {
                "code": 200,
                "success": "1"
            },
            "content": {
                "amount": this.retryCount,
                "is_first_game": true
            }
        }.content;
    }

    /**
     * Do a spin, get spin results (see API docs)
     */
    public async postSpin(): Promise<SpinResults> {

        const spinResult = MockAPI.SPIN_RESULTS.pop()

        const responseBody = {
            "status": {
                "code": 200,
                "success": "1"
            },
            "content": spinResult     
        };
        
        if (this.retryCount > 0) {
            this.retryCount--;
        }

        return responseBody.content;
    }
}
